import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2073b244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-text" }

import { withDefaults } from "vue";
import Icon from "./Icon.vue";

interface IProps {
  text: string;
  iconName?: string;
  iconCircle?: boolean;
  withIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleText',
  props: {
    text: {},
    iconName: { default: "" },
    iconCircle: { type: Boolean, default: false },
    withIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h2", _hoisted_1, [
    (_ctx.iconName)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          "icon-name": _ctx.iconName,
          "icon-circle": _ctx.iconCircle
        }, null, 8, ["icon-name", "icon-circle"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", {
      class: _normalizeClass({ 'with-icon': _ctx.iconName || _ctx.withIcon })
    }, _toDisplayString(_ctx.text), 3)
  ]))
}
}

})